import { XMarkIcon } from '@heroicons/react/24/outline';
import React from 'react';
import { NavLink } from 'react-router-dom';
import LogoImage from '../../../assets/images/brightspeed-logo-full-color.png';

// const navigation = [
// 	{ name: 'My Files', to: '/user-files' },
// 	{
// 		name: 'Connectors',
// 		children: [
// 			{ name: 'Sharepoint', to: '/sharepoint' },
// 			{ name: 'Confluence', to: '/confluence' },
// 			{ name: 'Jira', to: '/jira' },
// 		],
// 	},
// 	{ name: 'Database', to: '/database' },
// ];

const tools = [
	{ id: 1, name: 'Gen AI Studio', to: '/' },
	{ id: 9, name: 'Sales AA-Bright Insights', to: '/bright-insights' },
	// { id: 2, name: 'Email-Subject Lines', to: '/email-subject' },
	{ id: 3, name: 'Agent Assist', to: '/sales-script' },
	// { id: 4, name: 'Where is my Tech', to: '/where-is-my-tech' },
	// { id: 5, name: 'Sales AA-Admin Tool', to: '/admin-tool' },
	{ id: 6, name: 'Chatbot', to: '/chatbot' },
	{ id: 7, name: 'Care AA-Suggested Response', to: '/llm-response' },
	{ id: 8, name: 'Opportunity Analytics', to: '/opportunity-analytics' },
	{ id: 9, name: 'Callflow Script', to: '/callflow-script' },
	// { id: 9, name: 'Static Agent Assist', to: '/static-agent-assist' },
];

// const knowledge = [
// 	{ id: 1, name: 'ServiceNow', to: '/servicenow' },
// 	{ id: 2, name: 'AskHR', to: '/askhr' },
// 	{ id: 3, name: 'Brightspeed.com', to: '/brightspeed' },
// ];

function classNames(...classes: string[]) {
	return classes.filter(Boolean).join(' ');
}

const extractInitial = (name: string): string => {
	return name.charAt(0).toUpperCase();
};

interface SidebarProps {
	sidebarOpen: boolean;
	onSidebarToggle: () => void;
}

const DashboardSidebarLeft: React.FC<SidebarProps> = ({ sidebarOpen, onSidebarToggle }) => {
	return (
		<>
			{sidebarOpen && <div className="fixed inset-0 z-40 bg-black bg-opacity-50 lg:hidden" onClick={onSidebarToggle} />}

			{/* Sidebar nav*/}
			<div
				className={classNames(
					'lg:fixed lg:inset-y-0 lg:left-0 lg:z-50 lg:w-72 lg:flex lg:flex-col lg:translate-x-0 lg:transition-none',
					'fixed inset-y-0 left-0 z-40 w-72 bg-white border-r border-gray-200 transition-transform',
					sidebarOpen ? 'translate-x-0' : '-translate-x-full'
				)}
			>
				{/* Close button for small screens */}
				<div className="flex items-center justify-between h-16 p-4 lg:hidden bg-white">
					<div className="flex items-center text-gray-900 text-md gap-2 font-bold">
						<img src={LogoImage} width={120} height={20} alt="Brightspeed" />
						GenAI
					</div>
					<button onClick={onSidebarToggle} className="text-gray-500 hover:text-gray-900">
						<XMarkIcon className="h-6 w-6" aria-hidden="true" />
					</button>
				</div>

				{/* Sidebar content */}
				<div className="flex grow flex-col gap-y-2 overflow-y-auto bg-white border-r px-6 pb-4 ring-1 ring-white/10">
					<div className="hidden lg:flex h-16 gap-2 shrink-0 items-center text-gray-900 text-md font-bold">
						<img src={LogoImage} alt="Brightspeed" width={120} height={20} />
						GenAI
					</div>

					<nav className="flex flex-1 flex-col">
						<ul role="list" className="flex flex-1 flex-col gap-y-7">
							{/* <li>
								<ul role="list" className="-mx-2 space-y-1">
									{navigation.map((item) => (
										<li key={item.name}>
											{!item.children ? (
												<NavLink
													to={item.to}
													onClick={onSidebarToggle}
													className={classNames(
														'sidebar-navlink',
														'group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold'
													)}
												>
													<span
														className={classNames(
															'span-link',
															'flex h-6 w-6 shrink-0 items-center justify-center rounded-lg border border-gray-100 bg-white text-[0.625rem] font-medium text-gray-700 group-hover:text-gray-500'
														)}
													>
														{extractInitial(item.name)}
													</span>
													<span className="truncate">{item.name}</span>
												</NavLink>
											) : (
												<Disclosure as="div">
													{({ open }) => (
														<>
															<Disclosure.Button
																className={classNames(
																	'sidebar-navlink',
																	'flex items-center w-full text-left rounded-md p-2 gap-x-3 text-sm leading-6 font-semibold text-gray-700'
																)}
															>
																<ChevronRightIcon
																	className={classNames(
																		open ? 'rotate-90 text-gray-800' : 'text-gray-700',
																		'h-5 w-5 shrink-0'
																	)}
																	aria-hidden="true"
																/>
																{item.name}
															</Disclosure.Button>
															<Disclosure.Panel as="ul" className="mt-1 px-2">
																{item.children.map((subItem) => (
																	<li key={subItem.name}>
																		<NavLink
																			to={subItem.to}
																			onClick={onSidebarToggle}
																			className={classNames(
																				'block rounded-md py-2 pr-2 pl-9 text-sm leading-6 text-gray-600'
																			)}
																		>
																			{subItem.name}
																		</NavLink>
																	</li>
																))}
															</Disclosure.Panel>
														</>
													)}
												</Disclosure>
											)}
										</li>
									))}
								</ul>
							</li> */}
							<li>
								<div className="text-base font-semibold leading-6 text-gray-700 bg-gray-100 py-2 px-3 mb-4 rounded-md">
									Tools
								</div>
								<ul role="list" className="-mx-2 mt-2 space-y-1">
									{tools.map((tool) => (
										<li key={tool.name}>
											<NavLink
												to={tool.to}
												onClick={onSidebarToggle}
												className={classNames(
													'sidebar-navlink',
													'group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold'
												)}
											>
												<span
													className={classNames(
														'span-link',
														'flex h-6 w-6 shrink-0 items-center justify-center rounded-lg border border-gray-100 bg-white text-[0.625rem] font-medium text-gray-700'
													)}
												>
													{extractInitial(tool.name)}
												</span>
												<span className="truncate">{tool.name}</span>
											</NavLink>
										</li>
									))}
								</ul>
							</li>
							{/* <li>
								<div className="text-base font-semibold leading-6 text-gray-700 bg-gray-100 py-2 px-3 mb-4 rounded-md">
									Knowledge
								</div>
								<ul role="list" className="-mx-2 mt-2 space-y-1">
									{knowledge.map((item) => (
										<li key={item.name}>
											<NavLink
												to={item.to}
												onClick={onSidebarToggle}
												className={classNames(
													'sidebar-navlink',
													'group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold'
												)}
											>
												<span
													className={classNames(
														'span-link',
														'flex h-6 w-6 shrink-0 items-center justify-center rounded-lg border border-gray-100 bg-white text-[0.625rem] font-medium text-gray-700 group-hover:text-gray-500'
													)}
												>
													{extractInitial(item.name)}
												</span>
												<span className="truncate">{item.name}</span>
											</NavLink>
										</li>
									))}
								</ul>
							</li> */}
						</ul>
					</nav>
				</div>
			</div>
		</>
	);
};

export default DashboardSidebarLeft;
